module.exports = __webpack_public_path__ + "img/IDSLogo.5eccb7a6.png";